import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoModalAction, PoModalComponent, PoPageAction, PoPageFilter, PoSearchFilterMode, PoSelectOption, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { FiltroCarregamentosME } from '../../filter/filtro-carregamento-me';
import { PoStorageService } from '@po-ui/ng-storage';
import { defaultProgramacaoCarregamentoLista, ProgramacaoCarregamentoLista } from 'src/app/estoque/romaneio/interface/romaneio';
import { RomaneioService } from 'src/app/estoque/romaneio/service/romaneio.service';

@Component({
  selector: 'app-carregamentos-me-lista',
  templateUrl: './carregamentos-me-lista.component.html',
  styleUrl: './carregamentos-me-lista.component.css'
})
export class CarregamentosMeListaComponent implements OnInit{

  filtroPrincipal: FiltroCarregamentosME;

  tabelaPrincipalItems: Array<ProgramacaoCarregamentoLista> = [];

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private poDialogService: PoDialogService,
    private poStorageService: PoStorageService,
  ){
    this.filtroPrincipal = new FiltroCarregamentosME(this.poStorageService);
  };

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goTo.bind(this)},
      {label: 'Carregamentos ME'},
    ],
  };

  public readonly pageActions: Array<PoPageAction> = [
    { label: 'Incluir', action: this.bttnIncluir.bind(this) }
  ];

  public readonly optionsStatusCarregamento: Array<PoSelectOption> = [
    { value: "P", label: "Pendente"},
    { value: "F", label: "Finalizado"},
    { value: " ", label: "Todos"},
  ];

  public readonly tabelaPrincipalColumns: Array<PoTableColumn> = [
    {property: 'CZ07STATUS' , label: 'Status'           , width: '05%'  , type: 'subtitle',
      subtitles: [
        {value: 'P', color: 'color-08', content: 'P', label: 'Pendente'},
        {value: 'F', color: 'color-10', content: 'F', label: 'Finalizado'},
      ]
    },
    {property: 'CZ07CODIGO' , label: 'Código'           , width: '15%'} ,
    {property: 'DZ07DATINC' , label: 'Data Inclusão'    , width: '15%'  , type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ07HORINC' , label: 'Hora Inclusão'    , width: '15%'} ,
    {property: 'CUSERINCNM' , label: 'Usuário Inclusão' , width: '20%'} ,
    {property: 'DZ07DTFIM'  , label: 'Data Finalização' , width: '15%'  , type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ07HRFIM'  , label: 'Hora Finalização' , width: '15%'} ,
  ];

  public readonly tabelaPrincipalActions: Array<PoTableAction> = [
    { label: 'Excluir'              , icon: 'po-icon-delete'  , action: this.bttnExcluir.bind(this)           , disabled:this.disabledBttnExcluir.bind(this) },
    { label: 'E-mail Transp.'       , icon: 'po-icon-mail'    , action: this.bttnEmailTransp.bind(this)       , disabled:this.disabledBttnEmail.bind(this) },
    { label: 'Ret. Pendente'        , icon: 'po-icon-change'  , action: this.bttnRetornarPendente.bind(this)  , disabled:this.disabledbttnRetornarPendente.bind(this) },
  ];

  ngOnInit(): void {
  };

  tabelaPrincipalLoad(): void {
    this.filtroPrincipal.setStorage();
    this.romaneioService.getCarregamentosMELista(this.filtroPrincipal.dados).subscribe((ret) => {
      this.tabelaPrincipalItems = ret.items;
    })
  };

  bttnIncluir(): void {
    let dados: ProgramacaoCarregamentoLista = defaultProgramacaoCarregamentoLista();
    dados.COPERACAO = 'I';

    this.poDialogService.confirm({
      title: 'Incluir Carregamento',
      message: `Deseja realmente incluir um novo carregamento?`,
      confirm: () =>
      this.romaneioService.postCarregamentosME(dados).subscribe({
        next: () => {
          this.tabelaPrincipalLoad()
        }
      })
    });
  };

  bttnExcluir(row: ProgramacaoCarregamentoLista): void {
    row.COPERACAO = 'E';

    this.poDialogService.confirm({
      title: 'Excluir Carregamento',
      message: `Deseja realmente excluir o Carregamento ${row.CZ07CODIGO}?`,
      confirm: () =>
      this.romaneioService.postCarregamentosME(row).subscribe({
        next: () => {
          this.tabelaPrincipalLoad()
        }
      })
    });
  };

  bttnEmailTransp(row: ProgramacaoCarregamentoLista): void {
    this.poDialogService.confirm({
      title: 'Enviar E-mail',
      message: `Deseja enviar e-mail para as transportadoras deste carregamento ${row.CZ07CODIGO}?`,
      confirm: () =>
      this.romaneioService.emailCarregamentoTransportadoras(row.CZ07CODIGO).subscribe()
    });
  };

  bttnRetornarPendente(row: ProgramacaoCarregamentoLista): void {
    this.poDialogService.confirm({
      title: 'Retornar para Pendente',
      message: `Deseja realmente voltar o status do Carregamento ${row.CZ07CODIGO} para Pendente?`,
      confirm: () =>
      this.romaneioService.postRetornarPendenteCarregamentoME(row.NZ07RECNO).subscribe({
        next: () =>{
          this.tabelaPrincipalLoad()
        }
      })
    });
  };

  disabledBttnExcluir(row: ProgramacaoCarregamentoLista): boolean {
    return row.CZ07STATUS === 'F'
  };

  disabledBttnEmail(row: ProgramacaoCarregamentoLista): boolean {
    return row.NQTDZ00 === 0
  };

  disabledbttnRetornarPendente(row: ProgramacaoCarregamentoLista): boolean {
    return row.CZ07STATUS === 'P'
  };

  goTo(): void {
    this.router.navigateByUrl('')
  };

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  };

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
